import parse from 'html-react-parser';
import { FC } from 'react';
import style from './OptionalTermsOfUseStyle.module.css';
import { RoundSheet } from '@/components/uiParts/Sheet/RoundSheet/RoundSheet';

interface OptionalTermsOfUseProps {
  html?: string;
}

export const OptionalTermsOfUse: FC<OptionalTermsOfUseProps> = ({ html }) => {
  if (!html) return <></>;
  return (
    <RoundSheet>
      <div className={style['container']}>{parse(html)}</div>
    </RoundSheet>
  );
};
